import { FormControl, InputLabel, Select, MenuItem, Typography } from "./MyCustomFile"

const MySelectAddButton = ({ name, label, value, onChange, options, error, onBlur, helperText, disabled, status = false }) => {
    return (<>
        <FormControl fullWidth variant="outlined" margin="dense" size="small">
            <InputLabel style={{
                color: error ? "red" : "inherit", // Red if status is true, otherwise inherit default color
            }}>{label}{status ? "*" : ""}</InputLabel>
            <Select value={value || ''} name={name} onChange={onChange} label={label} error={error} onBlur={onBlur} disabled={disabled}>
                {Array.isArray(options) && options?.map((e, i) => (<MenuItem key={i} value={e.value}> {e.label}</MenuItem>))}
                {/* {addButton} */}
            </Select>
        </FormControl>
        {error && (<Typography variant="body2" style={{ color: "red", fontSize: "10px", marginLeft: "0" }}>{helperText}</Typography>)}
    </>);
}
export default MySelectAddButton